import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M6.984 7.378c.58 1.208 1.37 2.34 2.372 3.341a12.2 12.2 0 0 0 3.341 2.372c.104.05.156.075.222.094.233.068.52.02.718-.122.056-.04.103-.088.199-.183.291-.291.437-.437.583-.532a1.67 1.67 0 0 1 1.817 0c.146.095.292.24.584.532l.162.162c.443.443.664.665.785.902.239.473.239 1.032 0 1.505-.12.238-.342.46-.785.902l-.131.131c-.442.442-.663.663-.962.831-.333.187-.85.322-1.232.32-.344 0-.58-.067-1.05-.2a15.87 15.87 0 0 1-6.903-4.062 15.87 15.87 0 0 1-4.061-6.903c-.134-.47-.2-.706-.202-1.05a2.8 2.8 0 0 1 .32-1.232c.17-.3.39-.52.831-.962l.132-.131c.443-.443.664-.664.902-.785a1.67 1.67 0 0 1 1.504 0c.238.12.46.342.902.785l.163.162c.291.292.437.437.532.584.36.552.36 1.264 0 1.817-.095.146-.24.292-.532.583a2 2 0 0 0-.183.199.87.87 0 0 0-.122.718c.019.066.044.118.094.222"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }